// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3NjIR","errorLogs":"styles_errorLogs__36vVi"};